import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div 
      className={`inline-flex items-center bg-gray-100 rounded-full p-1 ${className}`}
      data-testid="language-switcher"
    >
      <button
        onClick={() => setLanguage('nl')}
        className={`px-3 py-1.5 text-sm font-semibold rounded-full transition-all duration-200 ${
          language === 'nl'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        data-testid="lang-nl-btn"
      >
        NL
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 text-sm font-semibold rounded-full transition-all duration-200 ${
          language === 'en'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
